// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"310c70a8","63":"14a733d2","245":"f92556ea","360":"835ea229","674":"22b8e053"}[chunkId] + ".chunk.css";
};